import React from "react";

import {
    FaCalendarAlt,
    FaSyncAlt,
    FaUndoAlt,
} from "react-icons/fa";


const DashboardFilter = ({
    filters = {},

    refreshing = false,

    onFromDateChange,

    onToDateChange,

    onApply,

    onRefresh,

    onReset,

    onQuickRange,
}) => {

    return (

        <div className="dashboard-filter-panel">

            {/* =====================================================
                LEFT
            ===================================================== */}

            <div className="dashboard-filter-left">

                <div className="dashboard-filter-title">

                    <FaCalendarAlt />

                    <div>

                        <strong>
                            Dashboard Period
                        </strong>

                        <span>
                            Filter complete business data by date
                        </span>

                    </div>

                </div>


                {/* =================================================
                    QUICK RANGE
                ================================================= */}

                <div className="dashboard-quick-ranges">

                    <button
                        type="button"
                        onClick={() =>
                            onQuickRange?.(
                                "TODAY"
                            )
                        }
                    >
                        Today
                    </button>


                    <button
                        type="button"
                        onClick={() =>
                            onQuickRange?.(
                                "YESTERDAY"
                            )
                        }
                    >
                        Yesterday
                    </button>


                    <button
                        type="button"
                        onClick={() =>
                            onQuickRange?.(
                                "THIS_WEEK"
                            )
                        }
                    >
                        This Week
                    </button>


                    <button
                        type="button"
                        onClick={() =>
                            onQuickRange?.(
                                "THIS_MONTH"
                            )
                        }
                    >
                        This Month
                    </button>


                    <button
                        type="button"
                        onClick={() =>
                            onQuickRange?.(
                                "THIS_YEAR"
                            )
                        }
                    >
                        This Year
                    </button>

                </div>

            </div>


            {/* =====================================================
                DATE RANGE
            ===================================================== */}

            <div className="dashboard-date-range">

                <div className="dashboard-date-control">

                    <label>
                        From Date
                    </label>

                    <div className="dashboard-date-input">

                        <FaCalendarAlt />

                        <input
                            type="date"

                            value={
                                filters
                                    ?.fromDate ||
                                ""
                            }

                            max={
                                filters
                                    ?.toDate ||
                                undefined
                            }

                            onChange={
                                (event) =>
                                    onFromDateChange?.(
                                        event
                                            .target
                                            .value
                                    )
                            }
                        />

                    </div>

                </div>


                <div className="dashboard-date-separator">
                    →
                </div>


                <div className="dashboard-date-control">

                    <label>
                        To Date
                    </label>

                    <div className="dashboard-date-input">

                        <FaCalendarAlt />

                        <input
                            type="date"

                            value={
                                filters
                                    ?.toDate ||
                                ""
                            }

                            min={
                                filters
                                    ?.fromDate ||
                                undefined
                            }

                            onChange={
                                (event) =>
                                    onToDateChange?.(
                                        event
                                            .target
                                            .value
                                    )
                            }
                        />

                    </div>

                </div>


                {/* =================================================
                    ACTIONS
                ================================================= */}

                <button
                    type="button"

                    className="dashboard-date-apply"

                    disabled={
                        !filters
                            ?.fromDate ||
                        !filters
                            ?.toDate
                    }

                    onClick={
                        onApply
                    }
                >
                    Apply
                </button>


                <button
                    type="button"

                    className="dashboard-filter-reset"

                    onClick={
                        onReset
                    }
                >
                    <FaUndoAlt />

                    Reset
                </button>


                <button
                    type="button"

                    className="dashboard-filter-refresh"

                    disabled={
                        refreshing
                    }

                    onClick={
                        onRefresh
                    }
                >
                    <FaSyncAlt
                        className={
                            refreshing
                                ? "dashboard-spin"
                                : ""
                        }
                    />

                    Refresh
                </button>

            </div>

        </div>

    );
};


export default DashboardFilter;